/* SQ1 home — ported verbatim from home-v8.html (scoped, guarded).
   Loaded (defer) by every sq1-* section; the window guard makes it run once. */
(function () {
  if (window.__sq1Home) return;
  window.__sq1Home = true;
  var d = document;
  d.documentElement.classList.add('sq1-js');

  // scallop direction alternation
  var scallops = d.querySelectorAll('svg.scallop');
  scallops.forEach(function (el, i) { if (i % 2) el.classList.add('rev'); });

  // voice strip quote rotation
  var quotes = [
    '“Your kid isn’t sleeping through the night yet cup of coffee.”',
    '“Your I bought this because I have to use the bathroom cup of coffee.”',
    '“Your she said this has floral notes but I just taste coffee cup of coffee.”',
    '“Your I wish there was whiskey in this cup of coffee.”',
    '“Your locally roasted and bagged by hand by Elizabeth cup of coffee.”'
  ];
  var qEl = d.getElementById('voiceQ');
  // a11y (WCAG 2.2.2): the auto-rotating quote never runs for reduced-motion users
  if (qEl && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var qi = 0;
    setInterval(function () {
      qEl.classList.add('fade');
      setTimeout(function () { qi = (qi + 1) % quotes.length; qEl.textContent = quotes[qi]; qEl.classList.remove('fade'); }, 280);
    }, 7000);
  }

  // sticky sampler bar
  var sb = d.getElementById('sampbar');
  var heroEl = d.querySelector('.sq1-scope .hero');
  var offerEl = d.getElementById('offer');
  if (sb) {
    // Shopify's draft preview bar covers bottom-fixed elements; lift above it
    var liftSb = function () {
      var pb = d.getElementById('PBarNextFrameWrapper') || d.getElementById('preview-bar-iframe');
      var h = pb ? (pb.getBoundingClientRect().height || 0) : 0;
      sb.style.bottom = h ? h + 'px' : '';
    };
    liftSb(); setTimeout(liftSb, 1200); setTimeout(liftSb, 3000);
  }
  if (sb && heroEl && offerEl) {
    var heroGone = false;
    var syncSampbar = function () {
      var nearOffer = Math.abs(offerEl.getBoundingClientRect().top) < innerHeight;
      sb.classList.toggle('on', heroGone && !nearOffer);
    };
    new IntersectionObserver(function (es) {
      heroGone = !es[0].isIntersecting;
      syncSampbar();
    }, { threshold: 0 }).observe(heroEl);
    addEventListener('scroll', syncSampbar, { passive: true });
  }

  // taste finder
  var answers = { how: null, taste: null };
  var cardsEls = [].slice.call(d.querySelectorAll('.sq1-scope .cards .card'));
  var finderGo = d.getElementById('finderGo');
  var nameOf = function (c) { var n = c.querySelector('.nm'); return n ? n.textContent.trim() : ''; };
  // routing pools from Jess (7/28): section renders available coffees per combo into JSON
  var routesEl = d.getElementById('sq1-finder-routes');
  var routes = null;
  if (routesEl) { try { routes = JSON.parse(routesEl.textContent); } catch (e) { routes = null; } }
  function pickMatch() {
    if (!answers.how || !answers.taste || !finderGo) return;
    var pool = routes ? (routes[answers.how + '|' + answers.taste] || []) : [];
    var pick = pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
    var name = pick ? pick.t : null;
    if (!name) {
      finderGo.innerHTML = 'Your coffee is<b id="finderOut"><a href="/collections/coffee" style="color:inherit;text-decoration:underline;text-underline-offset:3px">browsing all of them &rarr;</a></b>';
      cardsEls.forEach(function (c) { c.classList.remove('match'); });
      return;
    }
    cardsEls.forEach(function (c) { c.classList.toggle('match', nameOf(c) === name); });
    finderGo.innerHTML = 'Your coffee is<b id="finderOut"><a href="' + pick.u + '" style="color:inherit;text-decoration:underline;text-underline-offset:3px">' + name + ' &rarr;</a></b>';
    var m = cardsEls.filter(function (c) { return c.classList.contains('match'); })[0];
    if (m) m.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  d.querySelectorAll('.sq1-scope .finder .opts').forEach(function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      g.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on');
      b.setAttribute('aria-pressed', 'true');
      answers[g.dataset.q] = b.dataset.v;
      pickMatch();
    });
  });

  // hero micro-parallax (respects reduced motion)
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var heroCopy = d.querySelector('.sq1-scope .hero .copy');
    if (heroCopy && heroEl) {
      addEventListener('scroll', function () {
        var top = heroEl.getBoundingClientRect().top + scrollY;
        var y = Math.min(Math.max(scrollY - top, 0), innerHeight);
        heroCopy.style.transform = 'translateY(' + y * 0.18 + 'px)';
        heroCopy.style.opacity = 1 - (y / innerHeight) * 0.9;
      }, { passive: true });
    }
  }

  // record section: count-up + stagger
  var proofSec = d.querySelector('.sq1-scope .proof');
  if (proofSec) {
    var proofDone = false;
    var startProof = function () {
      if (proofDone) return; proofDone = true;
      proofSec.classList.add('seen');
      proofSec.querySelectorAll('.n[data-count]').forEach(function (el) {
        var target = +el.dataset.count; var t0 = performance.now();
        var tick = function (now) {
          var p = Math.min((now - t0) / 900, 1);
          el.innerHTML = Math.round(target * (p < .5 ? 2 * p * p : -1 + (4 - 2 * p) * p)) + '&times;';
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    };
    var proofIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { startProof(); proofIO.disconnect(); } });
    }, { threshold: .15 });
    proofIO.observe(proofSec);
    setTimeout(function () { if (scrollY + innerHeight > proofSec.getBoundingClientRect().top + scrollY) startProof(); }, 1200);

    // proof ledger dots (mobile swipe)
    var ledger = proofSec.querySelector('.ledger'), dots = proofSec.querySelector('.ledger-dots');
    if (ledger && dots) {
      var rows = ledger.querySelectorAll('.row');
      var build = function () {
        if (getComputedStyle(dots).display === 'none') { dots.innerHTML = ''; return; }
        if (dots.children.length === rows.length) return;
        dots.innerHTML = '';
        rows.forEach(function (r, i) { var dd = d.createElement('i'); if (i === 0) dd.className = 'on'; dots.appendChild(dd); });
      };
      var sync = function () {
        if (!dots.children.length) return;
        var c = ledger.scrollLeft + ledger.clientWidth / 2, best = 0, bd = 1e9;
        rows.forEach(function (r, i) { var m = r.offsetLeft + r.offsetWidth / 2, dd = Math.abs(m - c); if (dd < bd) { bd = dd; best = i; } });
        for (var i = 0; i < dots.children.length; i++) dots.children[i].className = i === best ? 'on' : '';
      };
      build();
      ledger.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', function () { build(); sync(); });
    }
  }

  // subscription pack-your-box preview (bag URLs injected by sq1-subscribe.liquid)
  var bags = window.SQ1_BAG_URLS || {};
  var pvModes = [
    { ttl: 'Your favorites, locked in', bd: 'Pick any of our coffees or teas. The same lineup lands on your schedule, 10% off, forever.',
      slots: [['bag-las-lajas.jpg', 'Your pick'], ['bag-sweet-street.jpg', 'Your pick'], ['bag-low-slow.jpg', 'Your pick']], price: '$20.40', unit: 'a bag, subscribed' },
    { ttl: 'A lane, rotated by Jess', bd: 'Chocolatey to floral, you choose the lane. A licensed Q Grader rotates the coffee inside it, familiar and new at once.',
      slots: [['bag-thaddeus.jpg', 'Month 1'], ['bag-sweet-street.jpg', 'Month 2'], ['bag-low-slow.jpg', 'Month 3']], price: '$20.40', unit: 'a bag, subscribed' },
    { ttl: "Whatever's singing right now", bd: 'Two people who taste for a living pack the box. Zero decisions, all discovery.',
      slots: [['bag-las-lajas.jpg', 'Could be'], ['bag-sweet-street.jpg', 'Could be'], [null, '?']], price: '$20.40', unit: 'a bag, subscribed' }
  ];
  var pvRow = d.getElementById('pvRow');
  function renderPv(i) {
    var m = pvModes[i];
    d.getElementById('pvTtl').textContent = m.ttl;
    d.getElementById('pvBd').textContent = m.bd;
    pvRow.innerHTML = m.slots.map(function (s, si) {
      var img = s[0], cap = s[1];
      return img
        ? '<div class="slot"><span class="slotlab">Slot 0' + (si + 1) + '</span><img src="' + (bags[img] || '') + '" alt="' + img.replace(/^bag-/, '').replace(/\.jpg$/, '').split('-').map(function (w) { return w[0].toUpperCase() + w.slice(1); }).join(' ') + ' 12oz bag"><em>' + cap + '</em></div>'
        : '<div class="slot q"><span class="slotlab">Slot 0' + (si + 1) + '</span><i>?</i><em>Roaster’s call</em></div>';
    }).join('');
    d.getElementById('pvPrice').textContent = m.price;
    d.getElementById('pvUnit').textContent = m.unit;
  }
  var subModes = d.getElementById('subModes');
  if (subModes && pvRow) {
    renderPv(0);
    subModes.addEventListener('click', function (e) {
      var b = e.target.closest('.mode'); if (!b) return;
      subModes.querySelectorAll('.mode').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      var sec = d.querySelector('.sq1-scope .subs');
      if (sec) sec.classList.add('swapping');
      setTimeout(function () { renderPv(+b.dataset.m); if (sec) sec.classList.remove('swapping'); }, 220);
    });
  }

  // reveal on scroll
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 });
  d.querySelectorAll('.sq1-scope .reveal').forEach(function (el) { io.observe(el); });
})();
